export const ai = {
  title: 'Your Language Expert',
  description: 'Learn languages interactively with a personal tutor that adapts to your level and goals',
  startChat: 'Start Chat',
  selectLanguage: 'Choose Learning Language',
  languageDescription: 'Select the language you want to master and begin your learning journey'
};